import React, { useEffect, useState } from "react";
import { Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";
import heartIconOutline from "../../../assets/icons/heart-outline.svg";
import heartIconFilled from "../../../assets/icons/heart-filled.svg";
import {
  addSavedJobToFirestore,
  deleteDocFromFirestore,
} from "../../firestore/firestoreService";
import { useDispatch, useSelector } from "react-redux";
import filter from "lodash/filter";
import ReactGA from "react-ga4";
import { FIRESTORE_SAVED_JOBS_COLLECTION } from "../../firestore/firestoreConstants";
import { openModal } from "../modals/modalReducer";
import { SIGN_UP_JOB_SEEKER_MODAL } from "../modals/ModalManager";
import { toast } from "react-toastify";

export default function SaveIconButton({
  isJobSeeker = false,
  isDisabled = false,
  margin = 0,
  floated,
  job,
  userId,
}) {
  const dispatch = useDispatch();

  const { savedJobs } = useSelector((state) => state.jobSeeker);
  const { isCookieConsent } = useSelector((state) => state.app);

  const [isIconOnHover, setIsIconOnHover] = useState(false);
  const [thisSavedJob, setThisSavedJob] = useState(null);
  const [isSaveJobLoading, setIsSaveJobLoading] = useState(false);

  useEffect(() => {
    setThisSavedJob(
      filter(savedJobs, (savedJob) => savedJob.jobId === job.id)[0]
    );
  }, [savedJobs, job]);

  async function handleClick(e) {
    e.stopPropagation();
    if (!isJobSeeker) {
      dispatch(
        openModal({
          modalType: SIGN_UP_JOB_SEEKER_MODAL,
          modalProps: { isShowBack: false },
        })
      );
      return;
    }

    try {
      if (isCookieConsent) {
        ReactGA.event({
          category: "Button",
          action: (thisSavedJob ? "Save" : "Un-save") + " job (job seeker)",
          label: job.refNumber,
        });
      }
      setIsSaveJobLoading(true);
      if (thisSavedJob) {
        await deleteDocFromFirestore({
          dbCollection: FIRESTORE_SAVED_JOBS_COLLECTION,
          id: thisSavedJob.id,
        });
      } else {
        await addSavedJobToFirestore(job, userId);
      }
    } catch (e) {
      toast.error("Could not save/un-save job");
    } finally {
      setIsSaveJobLoading(false);
    }
  }

  return (
    <Segment
      basic
      style={{ ...SEMANTIC_DIV, display: "inline-block", margin: margin }}
      vertical
      disabled={isDisabled}
      loading={isSaveJobLoading}
      floated={floated}
      onClick={handleClick}
      onMouseLeave={() => setIsIconOnHover(false)}
      onMouseEnter={() => setIsIconOnHover(true)}
      className="body-blue-text clickable"
    >
      <img
        style={{ width: 23, height: 21 }}
        src={isIconOnHover || thisSavedJob ? heartIconFilled : heartIconOutline}
        alt="heart"
      />
    </Segment>
  );
}
